/**
 * UTM Options API — POST /utm-options
 * Distinct UTM values (agent-scoped) to populate the clicks/leads dropdowns.
 */

import { BaseApi } from "./base.api";
import { LOS_API_BASE_URL } from "@/config";
import type {
  GetUtmOptionsRequest,
  GetUtmOptionsResponse,
  UtmOptions,
} from "@/types/utmOptions.types";

const EMPTY: UtmOptions = {
  utm_source: [],
  utm_medium: [],
  utm_term: [],
  utm_content: [],
  campaign_id: [],
  sub: [],
};

export class UtmOptionsApi extends BaseApi {
  constructor() {
    super(LOS_API_BASE_URL);
  }

  async getUtmOptions(request: GetUtmOptionsRequest): Promise<UtmOptions> {
    try {
      const response = await this.post<GetUtmOptionsResponse>(
        "/utm-options",
        request,
        true
      );
      if (response.success && response.data?.response) {
        return { ...EMPTY, ...response.data.response };
      }
      return EMPTY;
    } catch {
      // Non-fatal: dropdowns just render empty if this fails.
      return EMPTY;
    }
  }
}

export const utmOptionsApi = new UtmOptionsApi();
